import { useState } from "react";
import { X } from "lucide-react";

// Options First, Notes Second. Pick a preset reason; notes optional except "Other" (or when requireNote).
// Optional secondary options group (e.g. "Can this equipment be used?") — when provided it must also be answered.
export function ReasonModal({ title, subtitle, options = [], requireNoteFor = ["other"], requireNote = false,
  secondaryLabel, secondaryOptions = [], confirmLabel = "Confirm", onConfirm, onClose, testid = "reason-modal" }) {
  const [reason, setReason] = useState("");
  const [secondary, setSecondary] = useState("");
  const [note, setNote] = useState("");
  const hasOptions = options.length > 0;
  const hasSecondary = secondaryOptions.length > 0;
  const needNote = requireNote || (hasOptions && requireNoteFor.includes(reason));
  const baseValid = hasOptions ? (!!reason && (!needNote || note.trim())) : (!requireNote || note.trim());
  const valid = baseValid && (!hasSecondary || !!secondary);

  const submit = () => {
    if (!valid) return;
    const label = hasOptions ? (options.find((o) => o.key === reason)?.label || reason) : "";
    const parts = [label, note.trim()].filter(Boolean);
    const text = parts.join(" — ") || note.trim();
    onConfirm(text, { reason, secondary, note: note.trim() });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.6)" }}>
      <div className="sg-card p-6 w-full max-w-md sg-fade" style={{ maxHeight: "90vh", overflowY: "auto" }} data-testid={testid}>
        <div className="flex items-center justify-between mb-2">
          <h3 className="font-head text-xl font-bold">{title}</h3>
          <button onClick={onClose}><X size={22} /></button>
        </div>
        {subtitle && <p className="text-sm mb-4" style={{ color: "var(--txt2)" }}>{subtitle}</p>}
        {hasOptions && (
          <div className="flex flex-col gap-2 mb-3" data-testid={`${testid}-options`}>
            {options.map((o) => (
              <button key={o.key} onClick={() => setReason(o.key)} data-testid={`${testid}-opt-${o.key}`}
                className="sg-card-elev p-3 text-left text-sm font-semibold"
                style={{ border: reason === o.key ? "2px solid var(--accent)" : "1px solid var(--brd)", cursor: "pointer" }}>
                {o.label}
              </button>
            ))}
          </div>
        )}
        {hasSecondary && (
          <>
            <label className="text-xs uppercase tracking-wider" style={{ color: "var(--txt2)" }}>{secondaryLabel}</label>
            <div className="flex flex-col gap-2 my-2" data-testid={`${testid}-secondary`}>
              {secondaryOptions.map((o) => (
                <button key={o.key} onClick={() => setSecondary(o.key)} data-testid={`${testid}-sec-${o.key}`}
                  className="sg-card-elev p-3 text-left text-sm font-semibold"
                  style={{ border: secondary === o.key ? `2px solid ${o.tone || "var(--accent)"}` : "1px solid var(--brd)", cursor: "pointer", color: secondary === o.key && o.tone ? o.tone : "var(--txt)" }}>
                  {o.label}
                </button>
              ))}
            </div>
          </>
        )}
        <label className="text-xs uppercase tracking-wider" style={{ color: "var(--txt2)" }}>
          {needNote ? "Notes (required)" : "Additional notes (optional)"}
        </label>
        <textarea className="sg-input mt-1 mb-4" style={{ minHeight: 72, padding: 10 }} value={note} data-testid={`${testid}-note`}
          onChange={(e) => setNote(e.target.value)} placeholder={needNote ? "Required for this reason…" : "Optional context…"} />
        <button className="sg-btn sg-btn-accent w-full" disabled={!valid} onClick={submit} data-testid={`${testid}-confirm`}>{confirmLabel}</button>
      </div>
    </div>
  );
}
